export default "\r\n<app-staff-list></app-staff-list>\r\n\r\n\r\n";